module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel01_1280_1280_th-b36b6b18eeb15c00b48b5259eb7379d8.jpg";